export async function freeGatesUseCase(gateRepostitory) {
    const res = await gateRepostitory.free_gates();

    const gates = [];

    res.data.data.forEach(x => {
        gates.push(x.attributes);
    })

    return gates;
}